import styled from 'react-emotion';

export interface IFlexProps {
  align?:
    | 'center'
    | 'end'
    | 'normal'
    | 'stretch'
    | 'center'
    | 'start'
    | 'end'
    | 'flex-start'
    | 'flex-end'
    | 'self-start'
    | 'self-end'
    | 'baseline'
    | 'first baseline'
    | 'last baseline'
    | 'safe center'
    | 'unsafe center'
    | 'inherit'
    | 'initial'
    | 'unset';
  justify?:
    | 'center'
    | 'start'
    | 'end'
    | 'flex-start'
    | 'flex-end'
    | 'left'
    | 'right'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
    | 'safe center'
    | 'unsafe center'
    | 'inherit'
    | 'initial'
    | 'unset';
  padding?: string;
  height?: string;
}

const Column = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: ${(props: IFlexProps) => props.align};
  justify-content: ${(props: IFlexProps) => props.justify};
  padding: ${(props: IFlexProps) => props.padding};
  height: ${(props: IFlexProps) => props.height}
`;

export default Column;



// WEBPACK FOOTER //
// ./src/components/Column.ts